import { useState } from 'react';
import { Popover } from './Popover';
import { PopoverPlacements } from './constants';
import { Help24Colored, PopoverContentStyled, PopoverTriggerWithOutline } from './ClickTip.styles';

type ClickTipProps = {
  /** Determines where the popover will appear. */
  side?: PopoverPlacements;
  /** Content that shows up in the popover */
  popoverContentTitle: string | React.ReactNode;
  /** Content that shows up in the popover */
  popoverContentBody: string | React.ReactNode;
  /** Whether the ClickTip is being used in a modal */
  inModal?: boolean;
};

export const ClickTip: React.FC<React.PropsWithChildren<ClickTipProps>> = ({
  side = PopoverPlacements.Top,
  popoverContentTitle = '',
  popoverContentBody = '',
  inModal = false,
  ...props
}) => {
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverContentStyled
        TitleContent={popoverContentTitle}
        side={side}
        data-in-modal={inModal}
        {...props}
      >
        {popoverContentBody}
      </PopoverContentStyled>
      <PopoverTriggerWithOutline
        onClick={() => {
          setOpen(!open);
        }}
      >
        <Help24Colored data-active={open} />
      </PopoverTriggerWithOutline>
    </Popover>
  );
};

export const TopClickTip: React.FC<React.PropsWithChildren<ClickTipProps>> = (props) => (
  <ClickTip side={PopoverPlacements.Top} {...props} />
);
export const BottomClickTip: React.FC<React.PropsWithChildren<ClickTipProps>> = (props) => (
  <ClickTip side={PopoverPlacements.Bottom} {...props} />
);
export const RightClickTip: React.FC<React.PropsWithChildren<ClickTipProps>> = (props) => (
  <ClickTip side={PopoverPlacements.Right} {...props} />
);
export const LeftClickTip: React.FC<React.PropsWithChildren<ClickTipProps>> = (props) => (
  <ClickTip side={PopoverPlacements.Left} {...props} />
);

export default ClickTip;
